import React from "react";
import Spinner from "./Spinner";
import Icon from "./Icon";

const buttonStyles = {
  default: "text-white bg-black-500 hover:bg-am-700",
  white: "text-am-400 bg-white hover:bg-gray-50",
  secondary: "text-am-700 bg-indigo-100 hover:bg-indigo-200",
  danger: "text-white bg-red-600 hover:bg-red-700",
};

const TooltipIcon = ({
                      full,
                      className = "",
                      children,
                      styleType = "default",
                      submitting = false,
                      iconName,
                      label,
                      ...rest
                    }) => {
  let defaultClasses =
    "relative flex-wrap content-center uppercase border border-transparent font-medium rounded-full shadow-sm focus:outline-none active:opacity-70 ";

  if (buttonStyles[styleType]) {
    defaultClasses += buttonStyles[styleType];
  } else {
    defaultClasses += buttonStyles.default;
  }

  return (
    <button
      disabled={submitting}
      className={`${defaultClasses} ${full ? "w-full" : ""}`}
      {...rest}
    >
      <div className="flex flex-col items-center">
        <Icon iconName={iconName} className={className} />
        <h4 className="text-tiny text-center">{label}</h4>
      </div>
      {submitting ? (
        <Spinner classes={buttonStyles[styleType]} styleType={styleType}/>
      ) : null}
    </button>
  );
};

export default TooltipIcon;
